export const ADMIN_ORGANIZATION_LIST_PATH = '/admin/organizations';
export const ADMIN_ORGANIZATION_ADD_PATH = '/admin/organizations/add';
export const ADMIN_ORGANIZATION_EDIT_LIMITS_PATH = '/admin/organizations/:organizationId/limits';
